module.exports = __webpack_public_path__ + "img/individual_weddingrings_spread.87195f0.webp";